module.exports = __webpack_public_path__ + "img/system_t_view.be9075c9.jpg";